import { Injectable } from '@angular/core';
import { IRsaCryptoPort } from '../port/rsa-crypto.port';

@Injectable({
  providedIn: 'root',
})
export class WebRsaCryptoAdapter implements IRsaCryptoPort {
  async encryptCredentials(data: string, pem: string): Promise<string> {
    const publicKey = await this.importPublicKey(pem);

    if (!publicKey) {
      throw new Error(
        'Public key not set. Please import the public key first.',
      );
    }

    const encoder = new TextEncoder();
    const encodedData = encoder.encode(data);

    const encryptedData = await crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP',
      },
      publicKey,
      encodedData,
    );

    return btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
  }

  async importPublicKey(pem: string): Promise<CryptoKey> {
    const binaryDer = this.pemToArrayBuffer(pem);
    const publicKey = await crypto.subtle.importKey(
      'spki',
      binaryDer,
      {
        name: 'RSA-OAEP',
        hash: 'SHA-256',
      },
      true,
      ['encrypt'],
    );
    return publicKey;
  }

  pemToArrayBuffer(pem: string): ArrayBuffer {
    const pemContents = pem
      .replace(/-----BEGIN PUBLIC KEY-----/g, '')
      .replace(/-----END PUBLIC KEY-----/g, '')
      .replace(/\s/g, '');

    const binaryDer = Uint8Array.from(
      atob(pemContents),

      (c) => c.charCodeAt(0),
    );
    return binaryDer.buffer;
  }
}
